let REACT_APP_SERVER_WAREHOUSE_SERVER_BASE_URL =
  process.env.REACT_APP_SERVER_WAREHOUSE_SERVER_BASE_URL;
let REACT_APP_SERVER_WAREHOUSE_CLIENT_BASE_URL =
  process.env.REACT_APP_SERVER_WAREHOUSE_CLIENT_BASE_URL;

if (!REACT_APP_SERVER_WAREHOUSE_SERVER_BASE_URL) {
  console.error(
    "REACT_APP_SERVER_WAREHOUSE_SERVER_BASE_URL is not set in the environment!"
  );
  REACT_APP_SERVER_WAREHOUSE_SERVER_BASE_URL =
    "https://sb-local-server.ngrok.app";
  //"https://localhost.letscreate.zone:3010"; //"https://server-warehouse-local-server.letscreate.zone";
  console.warn(
    "REACT_APP_SERVER_WAREHOUSE_SERVER_BASE_URL not set - it has now been defaulted as",
    REACT_APP_SERVER_WAREHOUSE_SERVER_BASE_URL
  );
}

if (!REACT_APP_SERVER_WAREHOUSE_CLIENT_BASE_URL) {
  console.error(
    "REACT_APP_SERVER_WAREHOUSE_CLIENT_BASE_URL is not set in the environment!"
  );
  REACT_APP_SERVER_WAREHOUSE_CLIENT_BASE_URL =
    "https://localhost.letscreate.zone:8443"; //"https://server-warehouse-local-client.letscreate.zone";
  console.warn(
    "REACT_APP_SERVER_WAREHOUSE_CLIENT_BASE_URL not set - it has now been defaulted as",
    REACT_APP_SERVER_WAREHOUSE_CLIENT_BASE_URL
  );
}

export {
  REACT_APP_SERVER_WAREHOUSE_SERVER_BASE_URL,
  REACT_APP_SERVER_WAREHOUSE_CLIENT_BASE_URL,
};
